import { ICardInfoData } from "../interfaces/card-info.interface";

export const CARD_ICON_DIR = 'images/shared/cards'
export const CARD_BACKGROUND_DIR = 'images/shared/cards/backgrounds'

export const AppMarketingInfo: ICardInfoData[] = [{
    icon: `${CARD_ICON_DIR}/bag.png`,
    title: "app store optimization (aso)",
    text: "Boost your rankings in the App Store & Google Play."
},
{
    icon: `${CARD_ICON_DIR}/cheese.png`,
    title: "data-driven paid advertising",
    text: "Maximize ROI with targeted user acquisition."
},
{
    icon: `${CARD_ICON_DIR}/clock.png`,
    title: "retetion & engagement",
    text: "Maximize ROI with targeted user acquisition."
},
{
    icon: `${CARD_ICON_DIR}/camera.png`,
    title: "influencer & socia media marketing",
    text: "Amplify brand awareness and credibility."
}, {
    icon: `${CARD_ICON_DIR}/plant.png`,
    title: "comprehensive growth strategies",
    text: "Tailored solutions for startups & enterprises."
}]

export const AppMarketingInfoWithBackground: ICardInfoData[] = [
    {
        icon: `${CARD_BACKGROUND_DIR}/app-store.png`,
        title: "app store optimization (aso)",
        text: "SEM Nexus employs effective ASO strategies to enhance your app's visibility in app stores, driving organic downloads and ensuring sustainable growth."
    },
    {
        icon: `${CARD_BACKGROUND_DIR}/user.png`,
        title: "user acquisition",
        text: "Through targeted advertising campaigns on platforms like social media, search engines, and display networks, SEM Nexus attracts high-quality users to your app, optimizing your marketing spend for maximum ROI."
    },
    {
        icon: `${CARD_BACKGROUND_DIR}/influencer.png`,
        title: "influencer marketing",
        text: "Leveraging a robust network of influencers, SEM Nexus ensures your product becomes widely recognized and trusted, enhancing brand credibility and user engagement."
    },
    {
        icon: `${CARD_BACKGROUND_DIR}/development.png`,
        title: "app development",
        text: "Whether starting from scratch or taking over development from a previous team, SEM Nexus offers versatile app development services, ensuring quality and efficiency throughout the process."
    }]